import { BrandGradientDefs, type IllustrationProps, Sparkle } from "./common";

export function EmptyForms({ size = 120, ...props }: IllustrationProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      fill="none"
      aria-hidden
      {...props}
    >
      <BrandGradientDefs id="ef" />
      {/* Back document */}
      <rect
        x="50"
        y="42"
        width="100"
        height="120"
        rx="8"
        fill="url(#ef-fill)"
        stroke="url(#ef-stroke)"
        strokeWidth="1.5"
        opacity="0.4"
      />
      {/* Mid document */}
      <rect
        x="42"
        y="50"
        width="100"
        height="120"
        rx="8"
        fill="hsl(var(--background))"
        stroke="url(#ef-stroke)"
        strokeWidth="1.5"
        opacity="0.7"
      />
      {/* Front document with content lines */}
      <rect
        x="34"
        y="58"
        width="100"
        height="120"
        rx="8"
        fill="hsl(var(--background))"
        stroke="url(#ef-stroke)"
        strokeWidth="2"
      />
      <rect x="46" y="76" width="60" height="6" rx="3" fill="url(#ef-stroke)" opacity="0.7" />
      <rect x="46" y="92" width="76" height="4" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.4" />
      <rect x="46" y="104" width="50" height="4" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.4" />
      <rect x="46" y="116" width="68" height="4" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.4" />
      <rect x="46" y="138" width="40" height="14" rx="4" fill="url(#ef-stroke)" opacity="0.85" />

      {/* AI sparkles */}
      <Sparkle cx={158} cy={48} size={9} />
      <Sparkle cx={170} cy={66} size={6} opacity={0.5} />
    </svg>
  );
}
